import { getDefaultExportFromCjs as u } from "./ghl-ui.es436.js";
import { __module as o } from "./ghl-ui.es1693.js";
(function(a, r) {
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = n;
  function n(t) {
    if (t === null || t === !0 || t === !1)
      return NaN;
    var e = Number(t);
    return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  a.exports = r.default;
})(o, o.exports);
var f = o.exports;
const p = /* @__PURE__ */ u(f);
export {
  p as default,
  f as t
};
